"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGitHubNotification = void 0;
const repository_1 = require("./repository");
function fromGitHubNotification(notification) {
    if (!(notification && notification.id))
        return null;
    return {
        id: notification.id,
        isUnread: notification.unread === true,
        reason: notification.reason || '',
        subject: {
            type: notification.subject.type || '',
            title: notification.subject.title || '',
            url: notification.subject.url || '',
            latestCommentURL: notification.subject.latest_comment_url || '',
        },
        payload: {
            repository: notification.repository &&
                repository_1.fromGitHubRepository(notification.repository),
            comment: notification.comment,
            commit: notification.commit,
            issue: notification.issue,
            pullRequest: notification.pullRequest,
            release: notification.release,
        },
        last_read_at: notification.last_read_at || '',
        updatedAt: notification.updated_at || '',
    };
}
exports.fromGitHubNotification = fromGitHubNotification;
//# sourceMappingURL=notifications.js.map